<div [formGroup]="form" class="form">
  <mat-form-field class="w-100">
    <mat-label [translate]="'accounts/edition/test-link/generate-qr-code/pre-filled-text'"></mat-label>
    <input matInput formControlName="text" [maxlength]="textMaxLength" />
    <span class="text-muted" matSuffix>{{ form.value.text?.length || 0 }}/{{ textMaxLength }}</span>
  </mat-form-field>

  <app-select
    [items]="colorChoices"
    [control]="$any(form.get('color'))"
    labelKey="accounts/edition/test-link/generate-qr-code/qr-code-color"></app-select>

  <button
    type="button"
    mat-raised-button
    color="primary"
    translate="accounts/edition/test-link/generate-qr-code/generate"
    (click)="generate()"></button>
</div>

<div class="qr-code">
  <qrcode
    class="text-center"
    [style.background-color]="form.value.color === '2' ? '#000000' : ''"
    [qrdata]="form.getRawValue().url"
    [colorDark]="colorsHexadecimal[form.value.color].color"
    [colorLight]="colorsHexadecimal[form.value.color].background"
    elementType="canvas"
    errorCorrectionLevel="H"
    [margin]="4"
    [scale]="1"
    [width]="500"></qrcode>
  <small class="description" translate="accounts/edition/test-link/generate-qr-code/image-legend"></small>

  <div class="copy-url">
    <mat-form-field>
      <mat-label></mat-label>
      <input matInput [formControl]="$any(form.get('url'))" />
    </mat-form-field>

    <button type="button" mat-raised-button (click)="copyUrl()">
      <span translate="copy"></span>
    </button>
  </div>
</div>
